import { useState } from "react";

export interface ItemCommentsProps {
  clamped: boolean;
  children: string | null | undefined;
}

export function ItemComments({ clamped, children }: ItemCommentsProps) {
  const [commentsOpen, setCommentsOpen] = useState(false);
  if (clamped) {
    return (
      <>
        <button
          tabIndex={0}
          type="button"
          className="item--comments"
          data-test-id="item-comments"
          onClick={() => setCommentsOpen((prev) => !prev)}>
          {commentsOpen ? children : clampToLines(children ?? "", 2)}
        </button>
        {commentsOpen ? (
          <button
            tabIndex={0}
            type="button"
            className="item--comments-screen"
            data-test-id="item-comments-screen"
            onClick={() => setCommentsOpen((prev) => !prev)}
          />
        ) : null}
      </>
    );
  }

  return (
    <p className="item--comments" data-test-id="item-comments">
      {children}
    </p>
  );
}

function clampToLines(text: string, lines: number, charsPerLine = 50) {
  const targetCharLength = charsPerLine * lines;
  if (text.length > targetCharLength) {
    return (
      <>
        {text.slice(0, targetCharLength).trim()}
        <span className="item--comments-more">... more</span>
      </>
    );
  } else {
    return <>{text}</>;
  }
}
